import type { IconType } from "@circle-react/components/shared/Icon/IconNames";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { IconName, IconSize } from "@circleco/compass/components/Icon";

export interface IconButtonProperties {
  buttonSize: number;
  iconClassSize: string;
  iconName: IconType;
  iconSize: number;
}

export interface IconButtonPropertiesCircleV4 {
  icon: IconName;
  size: IconSize;
}

export const getIconButtonProperties = (
  bookmarkType: string,
  bookmarkId: number | null,
): IconButtonProperties => {
  if (bookmarkType === "lesson") {
    return {
      iconName: bookmarkId ? "16-bookmark-fill" : "16-bookmark",
      iconSize: 16,
      iconClassSize: "!w-4 !h-4",
      buttonSize: 24,
    };
  }
  if (bookmarkType === "message") {
    return {
      iconName: bookmarkId ? "16-bookmark-fill" : "16-bookmark",
      iconSize: 16,
      iconClassSize: classNames("!w-4 !h-4", {
        "!text-default": !bookmarkId,
      }),
      buttonSize: 24,
    };
  }

  return {
    iconName: bookmarkId ? "20-bookmark-fill" : "20-bookmark",
    iconSize: 20,
    iconClassSize: "!w-5 !h-5",
    buttonSize: 28,
  };
};

export const getIconButtonPropertiesCircleV4 = (
  bookmarkType: string,
  bookmarkId: number | null,
): IconButtonPropertiesCircleV4 => ({
  icon: bookmarkId ? "bookmark-filled" : "bookmark",
  size: bookmarkType === "lesson" || bookmarkType === "message" ? "sm" : "md",
});
